import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
//@ts-ignore cortex
import { useQueryString } from "@cortexglobal/cortex-utilities";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    PageTitle,
    Loading,
    Row,
    Panel,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";
import InventoryCategoryForm, {
    InventoryCategory,
} from "../../../forms/InventoryCategoryForm";
import { HeaderEmphasis } from "../../../components/index";

export const InventoryCategoryEdit = ({ uuid, path }) => {
    const history = useHistory();
    const page = useQueryString().get("page");

    const [item, setItem] = useState<{
        loaded: boolean;
        data?: InventoryCategory;
    }>({
        loaded: false,
        data: null,
    });
    const getItem = () => {
        setItem({ loaded: false, data: null });
        axios
            .get(`/api/v1/admin/inventory-category/${uuid}`)
            .then(({ data }) => {
                setItem({ loaded: true, data: data.data });
            });
    };

    useEffect(getItem, [uuid]);

    const submitForm = (values, setSubmitting) => {
        return axios
            .post(`/api/v1/admin/inventory-category/${uuid}`, values)
            .then(({ data }) => {
                // console.log(data);
                setSubmitting(false);
                setItem({
                    loaded: true,
                    data: data.data,
                });

                return data.data;
            });
    };

    return (
        <div>
            <PageTitle
                title={
                    <React.Fragment>
                        {trans("Edit Inventory Category")}{" "}
                        <HeaderEmphasis>
                            {item.data ? item.data.name : ""}
                        </HeaderEmphasis>
                    </React.Fragment>
                }
            >
                <IconTextButton
                    as={Link}
                    to={`${path}?page=${page ? page : 1}`}
                    rotation={180}
                    showCircle={false}
                    expanded={false}
                >
                    {trans("Back to listing")}
                </IconTextButton>
            </PageTitle>
            {item.loaded ? (
                <Row>
                    <Panel style={{ paddingBottom: "0" }}>
                        <InventoryCategoryForm
                            item={item.data}
                            submitForm={submitForm}
                        />
                    </Panel>
                </Row>
            ) : (
                <Loading />
            )}
        </div>
    );
};

export default InventoryCategoryEdit;
